/**
 * Generates non-secure IDs that should only be used in instances where security
 * and collision probability are not a concern (e.g HTML `id` attributes)
 */
export function unsecureID(prefix = '', size = 8): string {
  const characters =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  let id = prefix;

  for (let i = 0; i < size; i++) {
    id += characters[Math.floor(Math.random() * characters.length)];
  }

  return id;
}
